import { useRestaurant } from "@/lib/restaurantContext";
import { Link } from "react-router-dom";
import { ChevronDown, Plus, Store, CalendarClock } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export function RestaurantSwitcher() {
  const { restaurants, active, setActive } = useRestaurant();
  if (!restaurants) return null;

  const choose = (id) => {
    if (id === active?.id) return;
    setActive(id);
    // Full reload so every page (Menu, QR, Profile, Dashboard) refetches data
    // for the newly-selected outlet.
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg border border-border bg-white hover:border-brand-orange transition text-sm"
          data-testid="restaurant-switcher"
        >
          <span className="flex items-center gap-2 min-w-0">
            {active?.is_event ? <CalendarClock className="w-4 h-4 brand-orange shrink-0" /> : <Store className="w-4 h-4 brand-navy shrink-0" />}
            <span className="font-semibold truncate">{active?.name || "No outlet yet"}</span>
          </span>
          <ChevronDown className="w-4 h-4 text-foreground/50 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Your outlets</DropdownMenuLabel>
        {restaurants.length === 0 && (
          <div className="px-3 py-2 text-xs text-muted-foreground">No outlets yet — create one.</div>
        )}
        {restaurants.map((r) => (
          <DropdownMenuItem
            key={r.id}
            onClick={() => choose(r.id)}
            className={r.id === active?.id ? "bg-muted font-semibold" : ""}
            data-testid={`switcher-option-${r.id}`}
          >
            {r.is_event ? <CalendarClock className="w-3.5 h-3.5 mr-1 brand-orange" /> : <Store className="w-3.5 h-3.5 mr-1" />}
            {r.name}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/dashboard/restaurants" className="flex items-center gap-2 brand-orange font-semibold" data-testid="manage-outlets-link">
            <Plus className="w-3.5 h-3.5" /> Manage outlets
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
